import { ArrowCollapseRightIcon } from './ArrowCollapseRightIcon';

/**
 * author: Michael Richins
 * id FFED25A5-FD40-4274-9EE3-6B26F5C03584
 * name arrow-collapse-right
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse-right.svg
 * tags
 * - Arrow 
 */
export const ArrowCompressRightIcon = ArrowCollapseRightIcon;
export default ArrowCompressRightIcon